<div class="dialog-container">
  <h2 mat-dialog-title>Backdrop</h2>
  
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-dialog-content>
      <p class="dialog-description">This is the stage your script will be played on.</p>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Select Backdrop</mat-label>
        <mat-select formControlName="backdrop" (selectionChange)="onBackdropSelectionChange($event)">
          @for (backdrop of availableBackdrops; track backdrop.id) {
            <mat-option [value]="backdrop">
              {{ backdrop.name }}
            </mat-option>
          }
        </mat-select>
        <mat-error *ngIf="form.get('backdrop')?.hasError('required')">
          Please select a backdrop
        </mat-error>
      </mat-form-field>
      @if (selectedBackdrop) {
        <div class="backdrop-image-container">
          <img 
            class="backdrop-image" 
            [class.zoomed]="isZoomed"
            [src]="'https://jar.games/'+selectedBackdrop.img_url" 
            [alt]="selectedBackdrop.name" 
            (click)="onImageClick($event)" 
          />
        </div>
      }
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button  type="submit" [disabled]="!form.valid">
        Apply Changes
      </button>
    </mat-dialog-actions>
  </form>

  <!-- Zoom overlay -->
  @if (isZoomed) {
    <div class="zoom-overlay" (click)="onOverlayClick()">
      <div class="zoom-container">
        <img 
          class="zoomed-image" 
          [src]="'https://jar.games/'+selectedBackdrop?.img_url" 
          [alt]="selectedBackdrop?.name" 
          (click)="onImageClick($event)"
        />
      </div>
    </div>
  }
</div>
